import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useAppStore, type ThemeMode } from "../../shared/store/app";
import { useT } from "../../shared/i18n";

export function ThemeToggle() {
  const t = useT();
  const mode = useAppStore((s) => s.mode);
  const setMode = useAppStore((s) => s.setMode);

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={(_e, value: ThemeMode | null) => {
        if (value) setMode(value);
      }}
      size="small"
      fullWidth
    >
      <ToggleButton value="light">{t("themeLight")}</ToggleButton>
      <ToggleButton value="dark">{t("themeDark")}</ToggleButton>
      <ToggleButton value="system">{t("themeSystem")}</ToggleButton>
    </ToggleButtonGroup>
  );
}
